<template>
  <div class="row mb-3">
    <div class="col-6">
      <div class="d-table h-100 w-100">
        <h5 class="text-primary font-weight-bold mb-2 text-left d-table-cell align-middle">
          Cannabinoids
        </h5>
      </div>
    </div>
    <div class="col-6">
      <div class="d-table h-100 w-100 text-right">
        <i class="bushel-icon bushel-3x bushel-hex-grid" />
      </div>
    </div>
    <div
      v-if="showPredominateCanabinoid && predominateCanabinoidType && predominateCanabinoidType.displayName"
      class="col-12"
    >
      <div class="row">
        <div class="col-6">
          <div class="d-table h-100 w-100">
            <h6 class="text-light font-weight-normal mb-2 text-left d-table-cell align-middle text-sm">
              {{ predominateCanabinoidType.displayName }}
            </h6>
          </div>
        </div>
        <div class="col-6">
          <div class="d-table h-100 w-100">
            <h6 class="text-medium font-weight-bold mb-2 text-right d-table-cell align-middle text-lowercase">
              {{ checkAndRound(predominateCanabinoidMin) }}<span v-if="predominateCanabinoidMin && predominateCanabinoidMax"> - </span><span v-if="predominateCanabinoidMax">{{ checkAndRound(predominateCanabinoidMax) }}</span>{{ predominateCanabinoidUnit }}
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div
      v-for="cannabinoid in cannabinoids"
      :key="cannabinoid.id + '_' + cannabinoid.name + '_' + Math.random()"
      class="col-12 mb-2"
    >
      <div class="row">
        <div class="col-6">
          <div class="d-table h-100 w-100">
            <h6 class="text-light font-weight-normal mb-2 text-left d-table-cell align-middle text-sm">
              {{ cannabinoid.displayName }}
            </h6>
          </div>
        </div>
        <div class="col-6">
          <div class="d-table h-100 w-100">
            <h6 class="text-medium font-weight-bold mb-2 text-right d-table-cell align-middle text-lowercase">
              {{ cannabinoid.pivot.measurement }}{{ cannabinoid.pivot.measurement_type }}
            </h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkAndRound } from "@/services/reporting/reporting";

export default {
  props: {
    cannabinoids: { type: Array, required: true },
    showPredominateCanabinoid: { type: Boolean, default: false },
    predominateCanabinoidType: { type: Object, default: null },
    predominateCanabinoidMin: { type: [String, Number], default: null },
    predominateCanabinoidMax: { type: [String, Number], default: null },
    predominateCanabinoidUnit: { type: String, default: null },
  },
  methods: {
    checkAndRound,
  },
};
</script>
